
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxData.css';

const RedboxData = () => {
  return (
    <>
      <Helmet>
        <title>Redbox Data - Market Data & Financial Intelligence | Redbox Global</title>
        <meta
          name="description"
          content="Redbox Data provides comprehensive market data, historical datasets, real-time feeds, and financial intelligence for institutions and professionals."
        />
        <meta
          name="keywords"
          content="Redbox Data, market data, financial datasets, real-time data, historical market data, financial intelligence, investment data"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/data" />
        <meta property="og:title" content="Redbox Data - Market Data & Financial Intelligence" />
        <meta
          property="og:description"
          content="Access real-time and historical financial market data with Redbox Data."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Redbox Data - Market Data Platform" />
        <meta
          name="twitter:description"
          content="Comprehensive financial datasets and real-time market data with Redbox Data."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=630&fit=crop"
        />

        <link rel="canonical" href="https://redboxglobal.com/data" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Dataset",
            "name": "Redbox Data",
            "description":
              "Comprehensive real-time and historical market data for financial professionals.",
            "url": "https://redboxglobal.com/data",
            "publisher": {
              "@type": "Organization",
              "name": "Redbox Global"
            }
          })}
        </script>
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Redbox Data</h1>
          <p className="page-subtitle">
            Comprehensive market data and financial intelligence at scale
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a
            href="/article/redbox-data-overview"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=600&fit=crop"
                  alt="Financial data visualization"
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Data Platform</span> */}
                <h2>Power Your Decisions with Trusted Financial Data</h2>
                <p>
                  Redbox Data delivers high-quality real-time and historical datasets across
                  global markets. From equities and fixed income to derivatives and alternative
                  data, our platform supports deep analysis and confident decision-making.
                </p>
                <span className="article-meta">Explore Data</span>
              </div>
            </div>
          </a>

          {/* Article Cards */}
          <div className="content-grid">
            <a
              href="/article/real-time-data-feeds"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=600&h=400&fit=crop"
                    alt="Real-time data feeds"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Real-Time</span> */}
                  <h2>Low-Latency Real-Time Data Feeds</h2>
                  <p>
                    Access ultra-low latency data feeds for global exchanges, enabling fast,
                    accurate, and informed trading decisions.
                  </p>
                  <span className="article-meta">View Feeds</span>
                </div>
              </article>
            </a>

            <a
              href="/article/historical-market-data"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=400&fit=crop"
                    alt="Historical market data"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Historical</span> */}
                  <h2>Deep Historical Market Datasets</h2>
                  <p>
                    Analyze long-term trends with extensive historical data across asset classes
                    and global markets.
                  </p>
                  <span className="article-meta">Explore History</span>
                </div>
              </article>
            </a>

            <a
              href="/article/alternative-data"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop"
                    alt="Alternative financial data"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Alternative Data</span> */}
                  <h2>Alternative & Proprietary Data Sources</h2>
                  <p>
                    Gain unique insights with alternative datasets including sentiment,
                    macroeconomic indicators, and custom data solutions.
                  </p>
                  <span className="article-meta">Discover Data</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedboxData;
